var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 13.833H9.99992V15.1663H5.99992V13.833ZM11.2706 9.64101C11.9573 8.83701 12.6666 8.00567 12.6666 6.49967C12.6666 3.92701 10.5726 1.83301 7.99992 1.83301C5.42725 1.83301 3.33325 3.92701 3.33325 6.49967C3.33325 8.02301 4.04459 8.85167 4.73392 9.65301C4.97259 9.93167 5.21992 10.2203 5.45659 10.5523C5.55259 10.6897 5.70992 11.2163 5.85059 11.833H5.33325V13.1663H10.6666V11.833H10.1506C10.2926 11.215 10.4506 10.687 10.5459 10.5497C10.7806 10.2143 11.0299 9.92301 11.2706 9.64101ZM9.45459 9.78301C9.16525 10.1943 8.92392 11.1663 8.78392 11.833H7.21659C7.07725 11.165 6.83525 10.191 6.54259 9.77967C6.29242 9.4359 6.02636 9.10398 5.74525 8.78501C5.09592 8.02901 4.66659 7.52901 4.66659 6.49967C4.66659 4.66167 6.16192 3.16634 7.99992 3.16634C9.83792 3.16634 11.3333 4.66167 11.3333 6.49967C11.3333 7.51367 10.9046 8.01567 10.2566 8.77501C10.0079 9.06701 9.72592 9.39701 9.45459 9.78301Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.1b44d99e19f3b6f3de87b0596214420f.svg";
export { ForwardRef as ReactComponent };